//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/AME.js";
import "../no/Builder.js";
import "../AME/AME.ExtractAttributeAbsoluteBuilder.js";
import "../AME/AME.ExtractAttributeCurrentObjectBuilder.js";
import "../AME/AME.ExtractAttributeExternalObjectBuilder.js";
import "../AME/AME.ExtractAttributePortBuilder.js";
import "../AME/AME.ExtractAttributeRelativeBuilder.js";
let d=[[[1,"AbsoluteAttributeBuilder",0,"AME.ExtractAttributeAbsoluteBuilder",0],[1,"CurrentObjectAttributeBuilder",0,"AME.ExtractAttributeCurrentObjectBuilder",0],[1,"ExternalObjectAttributeBuilder",0,"AME.ExtractAttributeExternalObjectBuilder",0],[0,"ExtractType",1,0],[1,"PortAttributeBuilder",0,"AME.ExtractAttributePortBuilder",0],[1,"RelativeAttributeBuilder",0,"AME.ExtractAttributeRelativeBuilder",0]],[],[]];
SPLM.AME.ExtractAttributeBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.AME.ExtractAttributeBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.AME.ExtractAttributeBuilder.Type = Object.freeze({
    "CurrentObject" : "CurrentObject", "SelectObject" : "SelectObject", "DetermineByExpression" : "DetermineByExpression", "Port" : "Port", "ExternalObject" : "ExternalObject"});

export default SPLM;